module.exports = __webpack_public_path__ + "static/media/070-cloud.0515b6b8.svg";